import { initialStateLogin, useLogin } from "./login/state"
import { initialStateMain, useMain } from './main/state'
import { useApplications } from "./applications/state"
import { useContractsSignature } from "./signature/state"
import { useCommercialOffers } from "./commercialOffers/state"
import { initialStateDict, useDict } from "./dict/state"
import { initialStateCommon, useCommon } from "./common/state"
import { useListeners } from "./listeners/state"
import { useCompanies } from "./companies/state"
import { useContracts } from "./contracts/state"
import { useFinalExamination } from "./finalExamination/state"
import { usePrintingsDiplomas } from "./printingsDiplomas/state"
import { useFinality } from "./finality/state"
import { useUsers } from "./users/state"
import { initialStateMonitoring, useMonitoring } from "./dashboard/state"
import { useAddressNotConfirmed } from './addressNotConfirmed/state'
import { usePaymentNotifications } from './paymentNotifications/state'


/** Сброс состояний всех хранилищь */
export const resetStore = () => {
    useLogin.setState(initialStateLogin)
    useMain.setState(initialStateMain)
    useDict.setState(initialStateDict)
    useCommon.setState(initialStateCommon)
    
    useApplications.getState().clearStateApplications()
    useContractsSignature.getState().clearStateContractsSignature()
    useCommercialOffers.getState().clearCommercialOffersState()
    useListeners.getState().clearListenersState()
    useCompanies.getState().clearCompaniesState()
    useContracts.getState().clearContractsState()
    useFinalExamination.getState().clearFinalExaminationState()
    usePrintingsDiplomas.getState().clearPrintingDiplomasState()
    useFinality.getState().clearFinalityState()
    useUsers.getState().clearStateUsers()
    useAddressNotConfirmed.getState().clearAddressNotConfirmedState()
    usePaymentNotifications.getState().clearPaymentNotificationsState()
    useMonitoring.setState(initialStateMonitoring)
}